import { useMutation } from "react-query";
import http from "infra/http";

function useVincularUnidadeGrupo(id: string) {
  return useMutation(
    ({
      unidades,
      unidadesExcel,
    }: {
      unidades?: string[];
      unidadesExcel?: { numero: string; blocoQuadra?: string }[];
    }) => {
      return http.put(`/v1/grupo-unidade/vincular/${id}`, {
        unidades,
        unidadesExcel,
      });
    },
    { retry: false }
  );
}

export default useVincularUnidadeGrupo;
